import {globals} from "../variables";

export const pageLoadedChecker = () => {
  const everythingLoadedEvent = new Event('everythingLoaded');

  let everythingLoaded = setInterval(() => {
    if (/loaded|complete/.test(document.readyState)) {
      clearInterval(everythingLoaded)

      document.dispatchEvent(everythingLoadedEvent)

      globals.isLoaded = true;
    }
  }, 10);
}
